// @vue/component
export default {
	data() {
		return {
			taxonomy: null,
		};
	},
	computed: {
		taxonomySections() {
			if (!this.taxonomy || !Array.isArray(this.taxonomy.sections)) return [];

			const sectionsMap = {};
			this.taxonomy.sections.forEach(({ id, title, media_title, is_hidden_in_media_filter, topics }) => {
				if (!is_hidden_in_media_filter) {
					const topicsMap = {};
					if (Array.isArray(topics)) {
						// eslint-disable-next-line no-shadow
						topics.forEach(({ id, title }) => {
							topicsMap[id] = title;
						});
					}
					sectionsMap[id] = {
						title,
						media_title,
						topics: topicsMap,
					};
				}
			});

			return sectionsMap;
		},
		selectedTaxonomySection() {
			return this.taxonomySections[this.taxonomySection];
		},
		selectedTaxonomySectionTitle() {
			return this.selectedTaxonomySection ? this.selectedTaxonomySection.title : 'Все';
		},
		taxonomyTopics() {
			return this.selectedTaxonomySection ? this.selectedTaxonomySection.topics : [];
		},
		selectedTaxonomyTopic() {
			return this.taxonomyTopics[this.taxonomyTopic];
		},
		selectedTaxonomyTopicTitle() {
			return this.selectedTaxonomyTopic ? this.selectedTaxonomyTopic : 'Все';
		},
		taxonomyProjects() {
			return this.taxonomy ? this.taxonomy.projects : [];
		},
		selectedTaxonomyProjectTitle() {
			return this.taxonomyProjects[this.taxonomyProject] || 'Все';
		},
		taxonomyProducts() {
			return this.taxonomy ? this.taxonomy.products : [];
		},
		selectedTaxonomyProductTitle() {
			return this.taxonomyProducts[this.taxonomyProduct] || 'Все';
		},
		taxonomyTypes() {
			return this.taxonomy ? this.taxonomy.types : [];
		},
		selectedTaxonomyTypeTitle() {
			return this.taxonomyTypes[this.taxonomyType] || 'Все';
		},
		taxonomyType: {
			get() {
				return this.$route.query.taxonomy_type || '';
			},
			set(type) {
				this.$router.push({
					query: {
						...this.$route.query,
						taxonomy_type: type || undefined,
					},
				});
			},
		},
		taxonomyProject: {
			get() {
				return this.$route.query.taxonomy_project || '';
			},
			set(taxonomyProject) {
				this.$router.push({
					query: {
						...this.$route.query,
						taxonomy_project: taxonomyProject || undefined,
						page: undefined,
					},
				});
			},
		},
		taxonomyProduct: {
			get() {
				return this.$route.query.taxonomy_product || '';
			},
			set(taxonomyProduct) {
				this.$router.push({
					query: {
						...this.$route.query,
						taxonomy_product: taxonomyProduct || undefined,
						page: undefined,
					},
				});
			},
		},
		taxonomySection: {
			get() {
				return this.$route.query.taxonomy_section || '';
			},
			set(taxonomySection) {
				this.$router.push({
					query: {
						...this.$route.query,
						taxonomy_section: taxonomySection || undefined,
						page: undefined,
						taxonomy_topic: undefined,
					},
				});
			},
		},
		taxonomyTopic: {
			get() {
				return this.$route.query.taxonomy_topic || '';
			},
			set(taxonomyTopic) {
				this.$router.push({
					query: {
						...this.$route.query,
						taxonomy_topic: taxonomyTopic || undefined,
						page: undefined,
					},
				});
			},
		},
	},
};
